// extracted by css-extract-rspack-plugin
export default {"form":"form-_wIkws","fields":"fields-xZCV9R"};